import React from 'react';

function SettingsIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2518 9.00002C15.2518 9.28335 15.2268 9.55002 15.1935 9.81669L16.9518 11.1917C17.1102 11.3167 17.1518 11.5417 17.0518 11.725L15.3852 14.6084C15.2852 14.7917 15.0685 14.8667 14.8768 14.7917L12.8018 13.9584C12.3685 14.2834 11.9018 14.5667 11.3935 14.775L11.0768 16.9834C11.0518 17.1834 10.8768 17.3334 10.6685 17.3334H7.33515C7.12682 17.3334 6.95182 17.1834 6.92682 16.9834L6.61015 14.775C6.10182 14.5667 5.63515 14.2917 5.20182 13.9584L3.12682 14.7917C2.94349 14.8584 2.71849 14.7917 2.61849 14.6084L0.951819 11.725C0.851819 11.5417 0.893486 11.3167 1.05182 11.1917L2.81015 9.81669C2.77682 9.55002 2.75182 9.27502 2.75182 9.00002C2.75182 8.72502 2.77682 8.45002 2.81015 8.18335L1.05182 6.80835C0.893486 6.68335 0.843486 6.45835 0.951819 6.27502L2.61849 3.39169C2.71849 3.20835 2.93515 3.13335 3.12682 3.20835L5.20182 4.04169C5.63515 3.71669 6.10182 3.43335 6.61015 3.22502L6.92682 1.01669C6.95182 0.816687 7.12682 0.666687 7.33515 0.666687H10.6685C10.8768 0.666687 11.0518 0.816687 11.0768 1.01669L11.3935 3.22502C11.9018 3.43335 12.3685 3.70835 12.8018 4.04169L14.8768 3.20835C15.0602 3.14169 15.2852 3.20835 15.3852 3.39169L17.0518 6.27502C17.1518 6.45835 17.1102 6.68335 16.9518 6.80835L15.1935 8.18335C15.2268 8.45002 15.2518 8.71669 15.2518 9.00002ZM6.08515 9.00002C6.08515 10.6084 7.39349 11.9167 9.00182 11.9167C10.6102 11.9167 11.9185 10.6084 11.9185 9.00002C11.9185 7.39169 10.6102 6.08335 9.00182 6.08335C7.39349 6.08335 6.08515 7.39169 6.08515 9.00002Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SettingsIcon;
